/**
 * Allows you to await for {time} in ms
 *
 * @param time Ms
 */
export const wait = (time: number): Promise<void> =>
  new Promise((res) => {
    setTimeout(res, time);
  });
